const DEBUG: boolean = false;

export const CLIENT_ID: string = 'ya1b97otwu5pq5qywgpdhy7vd9j5z4';
export const PASSPORT_BASE_URL: string = DEBUG ? 'http://localhost:8001' : 'https://andreams-passport.herokuapp.com';
export const REDIRECT_URI: string = `${PASSPORT_BASE_URL}/twitch/redirect`;
export const SIGN_IN_WITH_TWITCH_URI: string = `https://id.twitch.tv/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code`;